import l from "@babel/runtime/helpers/esm/objectSpread2";
var x = {
  name: "applyMaxSize",
  enabled: !1,
  phase: "beforeWrite",
  requires: ["maxSize"],
  fn: function(i) {
    var t = i.state, p = i.options, o = p.margin, r = o === void 0 ? 0 : o, e = p.popperCtx, s = t.modifiersData.maxSize, n = s.width, m = s.height, a = l({}, t.styles.popper);
    t.placement.startsWith("top") || t.placement.startsWith("bottom") ? a.maxHeight = "".concat(m - r, "px") : a.maxWidth = "".concat(n - r, "px"), t.styles.popper = a, e == null || e.forceUpdate();
  }
};
export {
  x as applyMaxSize
};
